const accordionBtn = document.querySelectorAll('.accordion-collapse[data-bs-lazy-accordion]');

import loadContents from './content-loader';
import SwiperComponent from "./SwiperComponent";

if (accordionBtn.length > 0) {
    Array.from(accordionBtn).forEach((element, index) => {
        element.addEventListener('show.bs.collapse', function (event) {
            loadContents(event.target.querySelector('.accordion-body[data-load]'), (element) => {
                let swiperComponent = new SwiperComponent('is-swiper');
                swiperComponent.loadSwipers(element.querySelectorAll('.is-swiper[data-swiper-with-thumbs]'));
            })
        });
    });
}
